'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import AppTopNavNotification from '@/app/[locale]/(worlds)/components/AppTopNavNotification';
import AppTopNavSearch from '@/app/[locale]/(worlds)/components/AppTopNavSearch';
import IconOfflineGames from '@/components/assets/icon_download.svg';
import IconParentControl from '@/components/assets/icon_parental_control.svg';
import IconViverseLogo from '@/components/assets/icon_viverse_logo.svg';
import { useAuthContext } from '@/context/AuthContext';
import { useUAContext } from '@/context/UAContext';
import { Link, usePathname } from '@/i18n/navigation';
import { isVersionAtLeast } from '@/lib/app-version';
import { postMessageToMobileApp } from '@/lib/mobile-app-bridge';
import { cn } from '@/lib/utils';
import IconViversePlusLogo from '@/public/images/viverse-plus/icon_viverse_plus_logo.svg';
import { NavItemType } from '@/types/nav';
type AppTopNavProps = {
  navItems: NavItemType[];
  activeItem: string;
};
const MIN_APP_VERSION_TOP_NAV_ACTIONS = '1.5.0';
function LogoNavigation(t0) {
  const $ = _c(2);
  const {
    isGamePlus
  } = t0;
  let t1;
  if ($[0] !== isGamePlus) {
    t1 = isGamePlus ? <IconViversePlusLogo aria-hidden={true} /> : <IconViverseLogo aria-hidden={true} className="h-5 w-auto shrink-0" />;
    $[0] = isGamePlus;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default function AppTopNav(t0) {
  const $ = _c(26);
  const {
    navItems,
    activeItem
  } = t0;
  const t = useTranslations();
  const pathname = usePathname();
  const {
    isGamePlus
  } = useAuthContext();
  const {
    mobileAppVersion
  } = useUAContext();
  const shouldShowSearchNav = activeItem === "search" || pathname === "/search";
  let t1;
  if ($[0] !== mobileAppVersion) {
    t1 = isVersionAtLeast(mobileAppVersion, MIN_APP_VERSION_TOP_NAV_ACTIONS);
    $[0] = mobileAppVersion;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isSupportedAppVersion = t1;
  let t2;
  if ($[2] !== isGamePlus || $[3] !== shouldShowSearchNav) {
    t2 = shouldShowSearchNav ? <AppTopNavSearch /> : <LogoNavigation isGamePlus={isGamePlus} />;
    $[2] = isGamePlus;
    $[3] = shouldShowSearchNav;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isGamePlus || $[6] !== isSupportedAppVersion || $[7] !== shouldShowSearchNav || $[8] !== t) {
    t3 = isGamePlus && !shouldShowSearchNav && isSupportedAppVersion ? <><button type="button" aria-label={t("worlds-navigation.top-nav.kids-mode")} onClick={_temp}><IconParentControl /></button><button type="button" aria-label={t("worlds-navigation.top-nav.offline-games")} onClick={_temp2}><IconOfflineGames /></button></> : null;
    $[5] = isGamePlus;
    $[6] = isSupportedAppVersion;
    $[7] = shouldShowSearchNav;
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <AppTopNavNotification />;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3) {
    t5 = <div className="flex items-center gap-6">{t3}{t4}</div>;
    $[11] = t3;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t2 || $[14] !== t5) {
    t6 = <div className="flex h-16 items-center justify-between gap-6 px-4 backdrop-blur-[50px]">{t2}{t5}</div>;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== activeItem || $[17] !== navItems) {
    let t8;
    if ($[19] !== activeItem) {
      t8 = item => {
        if (!item.path) {
          return null;
        }
        const isActive = activeItem === item.id;
        return <Link key={item.id} href={item.path} className={cn("flex flex-1 flex-col items-center gap-2 rounded-[9px] px-1 py-1.5", isActive ? "h-10" : "h-8")}><span className={cn("text-center text-xs leading-[18px] font-semibold tracking-[0.15px] whitespace-nowrap", isActive ? "text-white" : "text-[#aaadb9]")}>{item.label}</span>{isActive && <div className="h-1 w-full shrink-0 rounded-full bg-white" />}</Link>;
      };
      $[19] = activeItem;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    t7 = navItems.map(t8);
    $[16] = activeItem;
    $[17] = navItems;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[21] !== t7) {
    t8 = <div className="flex cursor-pointer items-start px-4">{t7}</div>;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t6 || $[24] !== t8) {
    t9 = <div className="z-sticky sticky top-0 flex flex-col gap-0 bg-[#121216] pt-1">{t6}{t8}</div>;
    $[23] = t6;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}
function _temp2() {
  return postMessageToMobileApp({
    feature: "enter-offline-games"
  });
}
function _temp() {
  return postMessageToMobileApp({
    feature: "enter-kids-mode"
  });
}